import { FONT } from "@/styles/fonts"
import { makeStyles } from "@/utils/makeStyles"

const useStyles = makeStyles(() => ({
	large: {
		fontSize: FONT.size.large,
		lineHeight: "normal",
		fontFamily: "IBM Plex Sans, sans-serif"
	},
	default: {
		fontSize: FONT.size.default,
		lineHeight: "normal",
		fontFamily: "IBM Plex Sans, sans-serif"
	},
	small1: {
		fontSize: FONT.size.small1,
		lineHeight: "normal",
		fontFamily: "IBM Plex Sans, sans-serif"
	},
	small2: {
		fontSize: FONT.size.small2,
		lineHeight: "normal",
		fontFamily: "IBM Plex Sans, sans-serif"
	},
	smaller1: {
		fontSize: FONT.size.smaller1,
		lineHeight: "normal",
		fontFamily: "IBM Plex Sans, sans-serif"
	},
	smaller2: {
		fontSize: FONT.size.smaller2,
		lineHeight: "normal",
		fontFamily: "IBM Plex Sans, sans-serif"
	},
	smaller3: {
		fontSize: FONT.size.smaller3,
		lineHeight: "normal",
		fontFamily: "IBM Plex Sans, sans-serif"
	}
}))

export default useStyles